module.exports = __webpack_public_path__ + "media/images/lp/img_merit_02-bdf1749f5f4cf59d54755e76ed5e1cda.png";